import { ReactComponent as GenesysLogo } from 'src/components/svg/genesys-logo.svg';

export default function Logo() {
  return <GenesysLogo style={{ height: '42px', width: '27px' }} className='text-genesys-orange-base' />;
}
